// src/pages/settings/components/multiInputField.js
import React, { useCallback } from "react";
import { Button, Input } from "antd";
import { FaPlus, FaTrash } from "react-icons/fa";

const MultiInputField = ({ label, placeholder, value = [""], onChange }) => {
  const addItem = useCallback(() => onChange([...value, ""]), [value, onChange]);
  const removeItem = useCallback((index) => onChange(value.filter((_, i) => i !== index)), [value, onChange]);
  const updateItem = useCallback(
    (index, newVal) => {
      const updated = [...value];
      updated[index] = newVal;
      onChange(updated);
    },
    [value, onChange]
  );

  return (
    <div className="stg-multi-input">
      <span className="stg-label">{label}</span>
      <div className="stg-multi-input-list">
        {value.map((item, index) => (
          <div key={index} className="stg-multi-input-row">
            <Input placeholder={placeholder} value={item} onChange={(e) => updateItem(index, e.target.value)} />
            {value.length > 1 && <Button icon={<FaTrash />} onClick={() => removeItem(index)} danger />}
          </div>
        ))}
        <Button icon={<FaPlus />} onClick={addItem} type="dashed" block>
          Add {label}
        </Button>
      </div>
    </div>
  );
};

export default MultiInputField;
